import { Box, Divider, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadFile,
  getAnalyticsData,
} from "../../redux/actions/analyticsAction";
import KpiDetails from "./KPI/index";
import CostReport from "./Tiles/cost";
import Provision from "./Tiles/provision";
import SecurityDetails from "./Tiles/security";
import StatusReport from "./Tiles/status";
import VulnerabilitiesPassDueDetails from "./Tiles/vulnerabiltyPassDue";
import HomeToolbar from "./toolbar";

const Home = () => {
  const dispatch = useDispatch();
  const { allRegions } = useSelector((state) => state.stateFile);
  const { costAndSecurity = [], vulnerabilityDetails = [] } = useSelector(
    (state) => state?.analytics
  );
  const [state, setState] = useState({
    account: null,
    month: null,
    region: [],
  });

  useEffect(() => {
    const { account, month, region } = state;
    const regions = region.find((item) => item.region === "All regions")
      ? allRegions.map((item) => item.region)
      : region.map((item) => item.region);
    if (account && month && regions.length > 0) {
      const payload = {
        startDate: month?.startDate,
        endDate: month?.endDate,
        accountNumber: account?.accountNumber,
        region: regions,
      };
      dispatch(getAnalyticsData(payload));
    }
  }, [state, dispatch, allRegions]);

  const handleChange = (key, value) => {
    if (key === "account" && typeof window !== "undefined") {
      window.localStorage.setItem(
        "iac-selected-account",
        JSON.stringify(value)
      );
    }
    setState((prevState) => ({
      ...prevState,
      region: key === "account" ? [] : prevState.region, // clear the region filed on account change
      [key]: value,
    }));
  };

  const handleDownload = (callback) => {
    const { account, month, region } = state;
    const regions = region.find((item) => item.region === "All regions")
      ? allRegions.map((item) => item.region)
      : region.map((item) => item.region);
    const payload = {
      startDate: month?.startDate,
      endDate: month?.endDate,
      accountNumber: account?.accountNumber,
      region: regions,
    };
    dispatch(downloadFile(payload, callback));
  };

  return (
    <Box>
      <HomeToolbar state={state} onChange={handleChange} />
      <Divider sx={{ my: 3 }} />
      {costAndSecurity && (
        <>
          <KpiDetails data={costAndSecurity} />
          <Grid mt={2} container spacing={3} alignItems="stretch">
            <Grid item xs={12} lg={7}>
              <Provision
                data={costAndSecurity?.provisionServiceWiseCount || {}}
              />
            </Grid>
            <Grid item xs={12} lg={5}>
              <StatusReport data={costAndSecurity?.statusWiseCount || {}} />
            </Grid>
            <Grid item xs={12} lg={6}>
              <CostReport data={costAndSecurity?.costByService || []} />
            </Grid>
            <Grid item xs={12} lg={6}>
              <SecurityDetails
                data={costAndSecurity?.severityWiseCount || {}}
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              <VulnerabilitiesPassDueDetails
                data={vulnerabilityDetails || []}
                handleDownload={handleDownload}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default Home;
